import React, { Component } from "react";

const image = 'https://lagunaproperty.com/images/03-sanctuary-club_41.jpg';

export default class Section5 extends Component {
  render() {
    return (
      <div className="section5">
        <div className="content">
          <h2>Early check-in / late check-out*</h2>
          <p>*Subject to availability on day of arrival / departure</p>
        </div>
        <img src={image} alt="img" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Section5.js